/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * アカウント名
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    name: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    email: string;
    /**
     * 利用者種別 (1:全権管理者, 2:組織管理者, 3:一般)
     * @type {number}
     * @memberof UpdateAccountRequest
     */
    role: number;
    /**
     * 追加権限リスト（1: 個人情報閲覧、2: 配車、3: マスター登録、4: 返金）
     * @type {Array<number>}
     * @memberof UpdateAccountRequest
     */
    permissions: Array<number>;
}

/**
 * Check if a given object implements the UpdateAccountRequest interface.
 */
export function instanceOfUpdateAccountRequest(value: object): value is UpdateAccountRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function UpdateAccountRequestFromJSON(json: any): UpdateAccountRequest {
    return UpdateAccountRequestFromJSONTyped(json, false);
}

export function UpdateAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'role': json['role'],
        'permissions': json['permissions'],
    };
}

export function UpdateAccountRequestToJSON(json: any): UpdateAccountRequest {
    return UpdateAccountRequestToJSONTyped(json, false);
}

export function UpdateAccountRequestToJSONTyped(value?: UpdateAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'role': value['role'],
        'permissions': value['permissions'],
    };
}

